exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:769px){.num-request{float:right}}@media (max-width:768px){.num-request{margin-bottom:10px}}", ""]);

// exports
